import { getAssociatedObjectType, getObjectType } from '../../utils';
import http from 'hub-http/clients/apiClient';
import { transformPropertyDefinitions, transformPropertySources } from './transforms';
export async function fetchPropertyUpdates(context) {
  const {
    objectId,
    objectTypeId
  } = context;
  const objectType = getObjectType(objectTypeId);
  const results = await http.get(`enrichment-platform/v1/${objectType}/updates/${objectId}`);
  return (results === null || results === void 0 ? void 0 : results.properties) || {};
}
export async function fetchPropertyDefinitions(context) {
  const {
    objectTypeId,
    propertyUpdates
  } = context;
  const objectType = getObjectType(objectTypeId);
  const results = await http.post(`properties/v4/${objectType}/multi-get`, {
    data: Object.keys(propertyUpdates)
  });
  return transformPropertyDefinitions(results);
}
export async function fetchPropertySources(context) {
  const {
    currentUser,
    objectId,
    objectTypeId,
    propertyUpdates
  } = context;
  const results = await http.post('source-interpretation/v1/property-history', {
    data: {
      objectId,
      objectTypeId,
      portalId: currentUser.portalId
    }
  });
  return transformPropertySources({
    propertySources: results,
    propertyUpdates
  });
}
export async function fetchEnrichableAssociations(context) {
  const {
    objectId,
    objectTypeId
  } = context;
  const objectType = getObjectType(objectTypeId);
  const associatedObjectType = getAssociatedObjectType(objectTypeId);
  return await http.get(`enrichment-platform/v1/${objectType}/${objectId}/associated-${associatedObjectType}?includeObjectIds=true`);
}
export async function enrichProperties(context) {
  const {
    objectId,
    objectTypeId,
    selectedProperties
  } = context;
  const objectType = getObjectType(objectTypeId);
  await http.post(`enrichment-platform/v1/${objectType}/updates/apply/${objectId}`, {
    data: selectedProperties
  });
}

/**
 * In the future this may become configurable, but for the time being this
 * is set to false to ensure we don't overwrite existing user-defined values
 */
const SHOULD_OVERWRITE_ENRICHED_ASSOCIATIONS = false;
export async function enrichAssociations(context) {
  const {
    objectId,
    objectTypeId
  } = context;
  const objectType = getObjectType(objectTypeId);
  const associatedObjectType = getAssociatedObjectType(objectTypeId);
  await http.post(`enrichment-platform/v1/${objectType}/${objectId}/associated-${associatedObjectType}/apply?shouldOverwrite=${SHOULD_OVERWRITE_ENRICHED_ASSOCIATIONS}`);
}